module.exports = __webpack_public_path__ + "static/media/p6.75b25527.ogg";